import * as XLSX from 'xlsx';

const PLAN_SHEET = 'PLAN DE COM CALENDAIRE';
const MEDIA_SHEET = 'MEDIA PLANNING ANNUEL';

function sheetToMatrix(sheet) {
  const ref = sheet?.['!ref'];
  if (!ref) return [];

  const range = XLSX.utils.decode_range(ref);
  const matrix = [];
  for (let rowIndex = range.s.r; rowIndex <= range.e.r; rowIndex += 1) {
    const row = [];
    for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex += 1) {
      const address = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
      const cell = sheet[address];
      if (!cell) {
        row.push('');
        continue;
      }
      if (cell.w != null && String(cell.w) !== '') {
        row.push(String(cell.w));
      } else if (cell.v == null) {
        row.push('');
      } else {
        row.push(cell.v);
      }
    }
    matrix.push(row);
  }

  return matrix;
}

async function readSheetFromFile(file, sheetName) {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: 'array', cellDates: true });
  const sheet = workbook.Sheets[sheetName];
  if (!sheet) {
    throw new Error(`Feuille "${sheetName}" introuvable`);
  }

  return sheetToMatrix(sheet);
}

/**
 * @param {File} file
 * @returns {Promise<{ plan_matrix: unknown[][], media_matrix: unknown[][] }>}
 */
export async function readPlanDeComFromFile(file) {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: 'array', cellDates: true });

  const planSheet = workbook.Sheets[PLAN_SHEET];
  const mediaSheet = workbook.Sheets[MEDIA_SHEET];

  if (!planSheet) {
    throw new Error(`Feuille "${PLAN_SHEET}" introuvable`);
  }

  return {
    plan_matrix: sheetToMatrix(planSheet),
    media_matrix: mediaSheet ? sheetToMatrix(mediaSheet) : [],
  };
}

export { PLAN_SHEET, MEDIA_SHEET, readSheetFromFile };
